<div class="common-checkbox-list" [class.common-checkbox-list--disabled]="disabled">
  <div class="common-checkbox-list__title-row">
    <p class="common-checkbox-list__title c_500" *ngIf="titleKey">
      {{ titleKey | translate }}
    </p>
  </div>

  <div
    class="common-checkbox-list__options"
    [class.common-checkbox-list__options--rows]="layout === 'rows'"
    [class.common-checkbox-list__options--columns]="layout === 'columns'"
    [style.--munily-checkbox-list-columns]="columnsCount"
  >
    <div
      class="common-checkbox-list__option"
      *ngFor="let opt of options; let i = index"
    >
      <app-common-checkbox
        [id]="'munily-checkbox-list-' + i"
        [name]="'munily-checkbox-list'"
        [labelKey]="opt.labelKey"
        [labelParams]="opt.labelParams"
        [type]="checkboxType"
        [disabled]="disabled || !!opt.disabled"
        [bulletAllowUnselect]="true"
        [ngModel]="isChecked(opt.value)"
        (change)="onOptionToggle(opt.value, $event)"
      ></app-common-checkbox>
    </div>
  </div>
</div>

